import { useEffect } from "react";
import { trackPageViewV2 } from "@/services/analytics-adapter";
import MyProfileFlow from "../../components/MyProfileFlow";

export default function MyProfileAndMembershipPage() {
  useEffect(() => {
    trackPageViewV2({
      pageName: "My profile and membership",
      pageSubSection1: "My profile and membership",
      pageSubSection2: "My profile and membership: Minors",
      pageCategory: "My profile and membership",
    });
  }, []);

  return <MyProfileFlow />;
}
